import React from "react";
import styled from "@emotion/styled";

import Text from "@shared/components/Text";
import Button from "@ats/src/components/shared/Button";

interface Props {
  id?: string;
  title: string;
  qualifier?: string;
  actions?: React.ReactNode;
  onClear?: () => void;
  clearDisabled?: boolean;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export default function CompactFormSection(props: Props) {
  const {
    id,
    title,
    qualifier,
    actions,
    onClear,
    clearDisabled = false,
    children,
    footer,
  } = props;

  return (
    <Styled.Container>
      <Styled.Header id={id}>
        <Text as="h4" size="sm" weight="bold">
          {title}
        </Text>
        {qualifier && <Styled.Qualifier>{qualifier}</Styled.Qualifier>}
        <Styled.Actions>
          {actions ||
            (onClear && (
              <Button styleType="text" onClick={onClear} disabled={clearDisabled}>
                Clear
              </Button>
            ))}
        </Styled.Actions>
      </Styled.Header>

      {children}

      {footer && <Styled.Footer>{footer}</Styled.Footer>}
    </Styled.Container>
  );
}

/* Styled Components
======================================================= */
const Styled: any = {};

Styled.Container = styled.div`
  label: CompactFormSection;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
`;

Styled.Header = styled.div`
  label: CompactFormSection_Header;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 12px;
  color: ${(props: any) => props.theme.poly.color.primaryText};
`;

Styled.Qualifier = styled.span`
  label: CompactFormSection_Qualifier;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: ${(props: any) => props.theme.poly.color.secondaryText};
`;

Styled.Actions = styled.div`
  label: CompactFormSection_Actions;
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 16px;
`;

Styled.Footer = styled.div`
  label: CompactFormSection_Footer;
  margin-top: 16px;
`;
